import { CSSProperties, FC, useRef, useState } from 'react';
import { CellWrapper, useCellContext } from '@silevis/reactgrid';
import DangerousIcon from '@mui/icons-material/Dangerous';
import WarningIcon from '@mui/icons-material/Warning';
import { Typography } from '@mui/material';

interface IconCellProps {
  value: string;
  isExceedingBoundaries: boolean;
  isExceedingWeeklyWeight: boolean;
  onValueChanged: (data: string) => void;
  style?: CSSProperties;
}

function IconCell({
  value,
  onValueChanged,
  isExceedingWeeklyWeight,
  isExceedingBoundaries,
  style,
}: IconCellProps) {
  const getColor = () => {
    if (isExceedingBoundaries) {
      return 'warning.main';
    }
    if (isExceedingWeeklyWeight) {
      return 'warning.light';
    }
    return style?.color;
  };

  return (
    <CellWrapper
      onStringValueRequested={() => value}
      onStringValueReceived={(v) => null}
      style={{
        padding: '.2rem',
        textAlign: 'center',
        outline: 'none',
        ...style,
      }}
    >
      {isExceedingWeeklyWeight && !isExceedingBoundaries && (
        <WarningIcon
          sx={{ color: 'warning.light', fontSize: '16px', pr: '10px' }}
        />
      )}
      {isExceedingBoundaries && (
        <DangerousIcon
          sx={{ color: 'warning.main', fontSize: '16px', pr: '10px' }}
        />
      )}
      <Typography
        color={getColor()}
        sx={{
          fontSize: style?.fontSize,
          fontWeight: style?.fontWeight,
        }}
      >
        {value}
      </Typography>
    </CellWrapper>
  );
}

export default IconCell;
